import { Lightning } from '@lightningjs/sdk'
import ReadmoreScroller from './ReadMoreScroller'

export default class LargeText extends Lightning.Component {
  static _template() {
    return {
      DetailTextWrapper: {
        w: w => w,
        h: h => h,
        clipping: true,
        rtt: true,
        shader: { type: Lightning.shaders.FadeOut, bottom: 22 },
        DetailText: { w: w => w, x: 40, alpha: 0.01 },
      },
      ReadMoreScroller: { w: 10, x: 10, type: ReadmoreScroller, alpha: 0.001 },
    }
  }

  get finalTextHeight() {
    return this.tag('DetailText').finalH
  }

  set detailtext(v) {
    this.tag('DetailTextWrapper').w = this.w + 40
    this.tag('ReadMoreScroller').h = this.h + 20

    if (v && v.length) {
      const regex = /[\r\n]/gm
      this._detailtext = v.split(regex).filter(txt => txt.length > 0)

      this.descrMeta = {
        lineCnt: this._detailtext.length,
        lineHeight: 38,
        y: this.tag('DetailTextWrapper').y,
      }

      this.tag('DetailText').children = this._detailtext.map(txt => {
        return {
          w: this.w,
          text: {
            text: txt,
            fontSize: 28,
            lineHeight: this.descrMeta.lineHeight,
            textBaseline: 'Top',
          },
        }
      })

      this.tag('DetailText').y = 0

      this.tag('ReadMoreScroller').patch({
        y: this.tag('DetailText').y,
        h: this.h - 22,
      })

      this._reposition()

      this._setState('DetailText')
    } else {
      this.descrMeta = {}
      this._detailtext = null
      this.tag('DetailText').children.length = 0
    }
  }
  set setScrollerAlpha(v) {
    this.tag('ReadMoreScroller').patch({
      smooth: { alpha: [v, { duration: 0.3 }] },
    })
  }

  get dimensions() {
    return this.descrMeta
  }

  async _reposition() {
    let totHg = 0

    await this.tag('DetailText').children.map((textItem, idx) => {
      textItem.loadTexture()

      const calc_lineHeight = textItem.text.lineHeight,
        calc_linesLength = textItem.texture.source.renderInfo.lines.length,
        calc_fontSize = textItem.text.fontSize,
        calc_offsetY = textItem.text.offsetY,
        hg =
          calc_lineHeight * (calc_linesLength - 1) +
          0.5 * calc_fontSize +
          Math.max(calc_lineHeight, calc_fontSize) +
          calc_offsetY
      totHg += hg
      if (this.tag('DetailText').children.length - 1 > idx) {
        this.tag('DetailText').children[idx + 1].y = totHg
      }
    })

    this.totHg = totHg

    this.tag('DetailText').setSmooth('alpha', 1)

    this.descrMeta.height = this.totHg
    this.descrMeta.wrapperHeight = this.h
    this.descrMeta.stepSize =
      Math.floor((this.descrMeta.wrapperHeight / this.descrMeta.lineHeight) * 0.75) *
      this.descrMeta.lineHeight
    this.descrMeta.totalSteps = Math.ceil(
      (this.descrMeta.height - this.descrMeta.wrapperHeight) / this.descrMeta.stepSize
    )
    this.descrMeta.scrollPosition = 0
    this.descrMeta.scroller = this.descrMeta.height > this.tag('DetailTextWrapper').finalH

    this.tag('ReadMoreScroller').steps = this.descrMeta.totalSteps
  }

  _scrollText(dir) {
    const stepSize = this.descrMeta.stepSize,
      totalSteps = this.descrMeta.totalSteps

    let indPos = this.descrMeta.scrollPosition

    if (dir === 'up' && indPos > 0) {
      indPos--

      const newY = -(indPos * stepSize)

      this.tag('DetailText').setSmooth('y', newY)

      this.descrMeta.scrollPosition = indPos
    } else if (dir === 'down' && indPos < totalSteps) {
      indPos++

      const newY = -(indPos * stepSize)

      this.tag('DetailText').setSmooth('y', newY)

      this.descrMeta.scrollPosition = indPos
    }

    this.tag('ReadMoreScroller').position = indPos
    return indPos !== totalSteps
  }

  _focus() {
    this.tag('ReadMoreScroller').focusScrollPart = true
  }

  _unfocus() {
    this.tag('ReadMoreScroller').focusScrollPart = false
  }

  static _states() {
    return [
      class DetailText extends this {
        _handleDown() {
          return this._scrollText('down')
        }

        _handleUp() {
          this._scrollText('up')
        }

        _getFocused() {
          return this
        }
      },
    ]
  }
}
